module.exports = __webpack_public_path__ + "static/media/banner4.5432c6d8.jpg";